<template>
  <button class="flex items-center font-bold">
    <SvgIcon
      v-if="!isPlayed && !isDone"
      name="play-circle-2"
      :class="{ 'opacity-70 ': audioError }"
      style="height: 44px; width: 44px"
      @click.prevent="setAudioSource()"
    />
    <SvgIcon
      v-else-if="isPlayed && !isDone"
      name="pause-circle-2"
      style="height: 44px; width: 44px"
      @click.prevent="pauseAudio"
    />
    <SvgIcon
      v-else-if="isDone && !isPlayed"
      name="tube-spinner"
      class="size-11"
    />
  </button>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const emit = defineEmits(['on-play']);

const audioStore = useAudioStore();

const toast = useToast();

const audioError = ref(false);
const isDone = ref(false);

/** computed */
const playStoreAudio = computed(() => {
  return audioStore.getSrc;
});
const playThisAudio = computed(() => {
  if (!playStoreAudio.value || !props.data.path) return;
  return playStoreAudio.value.includes(props.data.path);
});
const isPlayed = computed(() => {
  return audioStore.isPlayed && playThisAudio.value;
});

/** methods */
const setAudioSource = () => {
  if (audioError.value) {
    return;
  }
  playAudio();
};

const playAudio = async () => {
  pauseAudio();
  isDone.value = true;
  const audio = await new Audio(`https://histrf.ru${props.data.path}`);
  audio.preload = 'metadata';

  audio.addEventListener('error', () => {
    audioError.value = true;
    toast.error('При загрузке аудиофайла произошла ошибка, попробуйте позже!');
  });

  audio.addEventListener('loadedmetadata', () => {
    if (
      audio.readyState > 1 ||
      (!isNaN(audio.duration) && audio.duration > 1)
    ) {
      audioStore.start({
        audio,
        data: props.data,
      });
      audioStore.showFixedAudioBar();
      audioStore.setCurrentAudioData(props.data);
      audioStore.setCurrent(props.data);
      emit('on-play');
      isDone.value = false;
    }
  });
};

const pauseAudio = () => audioStore.pause();
</script>
